import { render } from "./NotReady.vue?vue&type=template&id=de953efa&scoped=true"
import script from "./NotReady.vue?vue&type=script&lang=js"
export * from "./NotReady.vue?vue&type=script&lang=js"

import "./NotReady.vue?vue&type=style&index=0&id=de953efa&lang=scss&scoped=true"

import exportComponent from "/home/caleb/Desktop/apps/kff_ordering_portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de953efa"]])

export default __exports__